import React from 'react';
import './Contact.css';
import mainFront from '../images/Main-Front.png';
import mainBack from '../images/Main-Back.png';

export default function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="contact_wrapper">
        <div className="contact_intro">
          <p className="contact_eyebrow">Contact / Contatto</p>
          <h2 className="contact_title">Let’s connect • Mettiamoci in contatto</h2>
          <p className="section_subtitle">
            We offer services in both Italian and English. Invia una richiesta in
            italiano o inglese e ricevi una risposta rapida per il tuo progetto.
          </p>
        </div>

        <div className="contact_grid">
          <div className="contact_details card">
        
            <div className="contact_line">
              <span>Email / Email</span>
              <a href="mailto:Devlab.preventivi@gmail.com">Devlab.preventivi@gmail.com</a>
            </div>
            <div className="contact_line">
              <span>Phone / Telefono</span>
              <a href="tel:+393206863910">+39 320 686 3910</a>
            </div>
            <div className="contact_line">
              <span>Location / Sede</span>
              <p>Turin, Italy</p>
            </div>
            <div className="contact_line">
              <span>Hours / Orari</span>
              <p>Mon–Fri • 09:00–18:00</p>
            </div>
          </div>

          <div className="contact_cards">
            <div className="contact_card contact_card_front">
              <div className="contact_card_image">
                <img src={mainFront} alt="Business card front" />
              </div>
            </div>
            <div className="contact_card contact_card_back">
              <div className="contact_card_image">
                <img src={mainBack} alt="Business card back" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
